import { Component, OnInit } from '@angular/core';
import { ReportsService } from "../reports.service";
import { FileSaverService } from "../../shared/file-saver.servive";
import { DateHelperService } from "../../core/services/date-helper.service";
import { NotificationService } from "../../core/services/notification.service";
import { ReportTypes } from '../reports.enum';
import { FileType } from '../../shared/filetype.enum';

@Component({
  moduleId: module.id,
  selector: 'top-campaigns-report',
  template: `
<div>
  <svg class="icon xl clearfix">
      <use xlink:href='#med-campaigns-report' />
  </svg>
  <button class="button btn-main" (click)='downloadExcel()' title='Click to download report'>Top Campaigns Report</button>
</div>`
})

export class TopCampaignsReportComponent {
  constructor(
    private reportsService: ReportsService,
    private fileSaverService: FileSaverService,
    private dateHelperService: DateHelperService,
    private notificationService: NotificationService) { }

    downloadExcel() {
      this.notificationService.showInfo('Please wait! Your report will be downloaded shortly.');
      let currentDate = new Date();
      let fileName = `Top Campaigns Report_${this.dateHelperService.formatDayAndMonth(currentDate)}`;
      let file = `${fileName}.xlsx`;
      this.reportsService.generateReportFile(currentDate, currentDate, fileName, ReportTypes.TopCampaigns, FileType.Excel).subscribe(
          (data: Blob) => this.fileSaverService.downloadFile(data, file),
          () => { },
          () => { }
      )
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/top-campaigns-report/top-campaigns-report.component.ts